/*
 * Vue全局组件
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:09
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-20 13:49:54
 */
import Vue from 'vue'
import LayoutPanel from '@core/components/LayoutPanel'
import ExportExcelBox from '@core/components/ExportExcelBox'
import RemoteSelect from '@core/components/RemoteSelect'
import ButtonGutter from '@core/components/ButtonGutter'

const components = {
  LayoutPanel,
  ExportExcelBox,
  RemoteSelect,
  ButtonGutter,
}

for (const key in components) {
  let component = components[key]
  Vue.component(component.name, component)
}

Vue.prototype.$export = ExportExcelBox.export



// WEBPACK FOOTER //
// ./src/components/index.js